import classnames from 'classnames';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { ORDER_STATUS_KEY, ORDER_STATUS_OBJ, REFUND_STATUS_OBJ } from 'src/utils/staticData';

import './index.scss';

type Status = Exclude<ORDER_STATUS_KEY, 'all' | 99>;

const STATUS: { [key in Status]: { class: string; background: string } } = {
  // 待支付
  init: {
    class: 'wait_pay',
    background: require('./images/status-waitpay.png'),
  },
  // 支付失败
  failed: {
    class: 'pay_failure',
    background: require('./images/status-close.png'),
  },
  // 审核中
  reviewing: {
    class: 'in_review',
    background: require('./images/status-wait.png'),
  },
  // 审核失败
  review_failed: {
    class: 'review_failure',
    background: require('./images/status-close.png'),
  },
  // 待发货
  delivery_wait: {
    class: 'wait_deliever',
    background: require('./images/status-wait.png'),
  },
  // 已发货
  delivered: {
    class: 'has_deliever',
    background: require('./images/status-wait.png'),
  },
  // 已完成
  finished: {
    class: 'compelete',
    background: require('./images/status-complete.png'),
  },
  // 已退款
  refund_success: {
    class: 'compelete',
    background: require('./images/status-complete.png'),
  },
  // 支付中
  in_payment: {
    class: 'in_review',
    background: require('./images/status-wait.png'),
  },
  // 退款进行中
  refund_inprocess: {
    class: 'in_review',
    background: require('./images/status-wait.png'),
  },
  // 已取消
  timeout: {
    class: 'cancel',
    background: require('./images/status-cancel.png'),
  },
  closed: {
    class: 'cancel',
    background: require('./images/status-cancel.png'),
  },
  refund_fail: {
    class: 'cancel',
    background: require('./images/status-cancel.png'),
  },
  expire_cancel: {
    class: 'cancel',
    background: require('./images/status-cancel.png'),
  },
};

const Countdown = ({ orderTime, cancelOrderCb }) => {
  console.info('orderTime', orderTime);
  const [minute, setMinute] = useState(0);
  const [second, setSecond] = useState(0);
  const expiredTime = dayjs(orderTime).add(30, 'minute');

  useEffect(() => {
    const si = setInterval(() => {
      const diffMinutes = dayjs(expiredTime).diff(dayjs(), 'minute');
      const diffSeconds = dayjs(expiredTime).diff(dayjs(), 'second') - diffMinutes * 60;
      console.info('diffMinutes', diffMinutes, diffSeconds);
      if (diffSeconds >= 0 && diffMinutes >= 0) {
        setMinute(() => {
          return diffMinutes;
        });
        setSecond(() => {
          return diffSeconds;
        });
      }

      if (diffMinutes === 0 && diffSeconds === 0) {
        cancelOrderCb?.();
      }
    }, 1000);
    return () => clearInterval(si);
  }, [cancelOrderCb, expiredTime]);

  const zeroPad = (value) => {
    if (value < 10) {
      return `0${value}`;
    }
    return value;
  };
  const zeroPadMinute = zeroPad(minute);
  const zeroPadSecond = zeroPad(second);
  if (zeroPadMinute === '00' && zeroPadSecond === '00') {
    return null;
  }
  return (
    <span className="countdown">
      请在{zeroPadMinute}分{zeroPadSecond}秒 内支付
    </span>
  );
};

interface OrderStatusHeaderProps {
  status: Status;
  orderTime: string;
  orderRefund: any;
  cancelOrderCb?: () => void;
}

const OrderStatusHeader = ({ status, orderTime, orderRefund, cancelOrderCb }: OrderStatusHeaderProps) => {
  if (!status) {
    return null;
  }
  const renderData = STATUS[status];
  const statusInfo = ORDER_STATUS_OBJ[status];
  return (
    <div className={classnames('order-status-header', renderData.class)}>
      <img className="background-image" alt="" src={renderData.background} />
      <div className="status">
        <span>{statusInfo}</span>
        {orderRefund && <span className="onRefund">{REFUND_STATUS_OBJ[orderRefund.refundStatus]}</span>}
        {status === 'init' && <Countdown orderTime={orderTime} cancelOrderCb={cancelOrderCb} />}
      </div>
    </div>
  );
};

OrderStatusHeader.defaultProps = {
  cancelOrderCb: undefined,
};

export default OrderStatusHeader;
